export default __webpack_public_path__ + "static/media/S.b19d347b.wav";